module.exports = __webpack_public_path__ + "static/media/partner-13.bbbc920e.webp";